import { render } from "./ClassSetting.vue?vue&type=template&id=287de42e&ts=true"
import script from "./ClassSetting.vue?vue&type=script&lang=ts"
export * from "./ClassSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__